import { render } from "./reduction_info.vue?vue&type=template&id=ca1c2a92"
import script from "./reduction_info.vue?vue&type=script&lang=js"
export * from "./reduction_info.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/info_block/reduction_info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca1c2a92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca1c2a92', __exports__)) {
    console.log('reload')
    api.reload('ca1c2a92', __exports__)
  }
  
  module.hot.accept("./reduction_info.vue?vue&type=template&id=ca1c2a92", () => {
    console.log('re-render')
    api.rerender('ca1c2a92', render)
  })

}


export default __exports__